import moment from 'moment'

export function getTecPassword(data = new Date()) {
    const dataBase = moment('2011-06-13')
    const dataHoje = moment(data)
    const diasEntre = -dataBase.diff(dataHoje, 'days')

    const dataSenha = dataHoje.add(diasEntre, 'days')
    const dia = dataSenha.get('date')
    const mes = dataSenha.get('month') + 1
    const ano = dataSenha.get('year')

    const calc = (dia * 12 + mes * 12 * 4 + ano * 68) * diasEntre

    return calc
        .toString()
        .substr(-6)
        .padStart(6, '0')
}
